import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, IsUUIDWithLVS, nameOf, StoreItemPromotionRelationType } from '@goparrot/common';
import { ApiExtraModels, ApiProperty, ApiPropertyOptional, refs } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsInstance, IsNotEmpty, IsNumber, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
import { FixtureBaseOrderStoreItemElementDto } from './FixtureBaseOrderStoreItemElementDto';
import { FixtureBaseStoreItemPromotionTargetRelationDto } from './FixtureBaseStoreItemPromotionTargetRelationDto';
import { FixtureElementTotalAmountsDto } from './FixtureElementTotalAmountsDto';
import { FixtureStoreItemAddedPromotionTargetRelationDto } from './FixtureStoreItemAddedPromotionTargetRelationDto';
import { FixtureStoreItemDiscountedPromotionTargetRelationDto } from './FixtureStoreItemDiscountedPromotionTargetRelationDto';
import { FixtureStoreItemDiscountPromotionProducerRelationDto } from './FixtureStoreItemDiscountPromotionProducerRelationDto';
let FixtureOrderElementDto = class FixtureOrderElementDto extends FixtureBaseOrderStoreItemElementDto {
};
__decorate([
    ApiProperty({ type: () => String, description: 'Element title', example: 'QA Mango Margarita' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureOrderElementDto.prototype, "title", void 0);
__decorate([
    ApiProperty({
        type: () => Number,
        description: "The price for a single unit of the item includes modifier's total price. The amount is calculated as the sum of the item basePrice and each modifier's total price.",
        example: 0.25,
    }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureOrderElementDto.prototype, "price", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'md5 of item state (selected modifiers + notes + loyalty)', example: '5dabe5562833a2a5fa8c4fca6ed4df3c' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureOrderElementDto.prototype, "uniqueName", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Element quantity', example: 1 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], FixtureOrderElementDto.prototype, "quantity", void 0);
__decorate([
    ApiPropertyOptional({
        oneOf: refs(FixtureStoreItemAddedPromotionTargetRelationDto, FixtureStoreItemDiscountedPromotionTargetRelationDto, FixtureStoreItemDiscountPromotionProducerRelationDto),
        description: 'passed from promotions',
    }),
    Type(() => FixtureBaseStoreItemPromotionTargetRelationDto, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: nameOf('type'),
            subTypes: [
                { value: FixtureStoreItemAddedPromotionTargetRelationDto, name: StoreItemPromotionRelationType.ADDED },
                { value: FixtureStoreItemDiscountedPromotionTargetRelationDto, name: StoreItemPromotionRelationType.DISCOUNTED },
                { value: FixtureStoreItemDiscountPromotionProducerRelationDto, name: StoreItemPromotionRelationType.DISCOUNT_PRODUCER },
            ],
        },
    }),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], FixtureOrderElementDto.prototype, "tag", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Element note. Passed from webstore', example: 'Without sugar' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureOrderElementDto.prototype, "notes", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Element unique name detailed' }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ],
    }),
    __metadata("design:type", String)
], FixtureOrderElementDto.prototype, "uniqueNameDetailed", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => String,
        description: "ref to the storeitem.menu-concepts['uniqueName']. If the functionality of the menu concepts is enabled, then this field should always be present",
        example: '1534fbef-7781-4fb0-9843-e606ee29dc22',
    }),
    IsUndefinable({ always: true }),
    IsUUIDWithLVS('4'),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureOrderElementDto.prototype, "menuConceptUuid", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => String,
        description: 'ref to the parent order bundle element. It is required when the element is a part of the bundle',
        example: 'Parent unique name',
    }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureOrderElementDto.prototype, "parentUniqueName", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => String,
        description: 'ref to the parent order bundle store item property uid. It is required when the element is a part of the bundle',
        example: 'Parent property uuid',
    }),
    IsUndefinable({ always: true }),
    IsUUIDWithLVS('4'),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureOrderElementDto.prototype, "parentPropertyUid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => FixtureElementTotalAmountsDto, description: 'Various total sums of money in cents received for this item' }),
    Type(() => FixtureElementTotalAmountsDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(FixtureElementTotalAmountsDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", FixtureElementTotalAmountsDto)
], FixtureOrderElementDto.prototype, "totalAmounts", void 0);
FixtureOrderElementDto = __decorate([
    ApiExtraModels(FixtureStoreItemAddedPromotionTargetRelationDto, FixtureStoreItemDiscountedPromotionTargetRelationDto, FixtureStoreItemDiscountPromotionProducerRelationDto)
], FixtureOrderElementDto);
export { FixtureOrderElementDto };
//# sourceMappingURL=FixtureOrderElementDto.js.map